export default __webpack_public_path__ + "static/media/Factory1.479f1aba.jpg";